import { ApolloError } from "@apollo/client";

export function isUnauthorized(errors: ApolloError): boolean {
  return errors && !!errors.graphQLErrors.find((e) => e.message === "Not authorized");
}
